import { CTA } from '@volkswagen-onehub/components-core';
import React from 'react';

interface Props {
	label?: string;
	emphasis?: 'primary' | 'secondary';
}

export const CloseLayerCTA = (props: Props) => {
	const { label, emphasis } = props;
	const closeButton = document.querySelector<HTMLButtonElement>('button[aria-label="closePopUp"]');

	const handleClose = () => {
		closeButton?.click();
	};

	return closeButton ? (
		<CTA tag="button" onClick={handleClose} emphasis={emphasis || 'secondary'}>
			{label || 'Cerrar'}
		</CTA>
	) : null;
};
